type ColorType = 'green' | 'red' | 'blue' | 'yellow' | 'orange';
const colorSchema = {
  green: {
    gradient:
      'linear-gradient(to right, var(--colors-campaign-green-1), white)',
    topGradient: `linear-gradient(to right, var(--colors-campaign-green-4), var(--colors-campaign-green-2))`,
    cardText: 'text-campaign/green-4',
    button: {
      border: 'border-colors/campaign-green-4',
      text: 'text-colors/campaign-green-4',
    },
  },
  red: {
    gradient: 'linear-gradient(to right, var(--colors-campaign-red-1), white)',
    topGradient: `linear-gradient(to right, var(--colors-campaign-red-4), var(--colors-campaign-red-2))`,
    cardText: 'text-campaign/red-3',
    button: {
      border: 'border-colors/campaign-red-3',
      text: 'text-colors/campaign-red-3',
    },
  },
  blue: {
    gradient: 'linear-gradient(to right, var(--colors-campaign-blue-1), white)',
    topGradient: `linear-gradient(to right, var(--colors-campaign-blue-4), var(--colors-campaign-blue-2))`,
    cardText: 'text-campaign/blue-4',
    button: {
      border: 'border-colors/campaign-blue-4',
      text: 'text-colors/campaign-blue-4',
    },
  },
  yellow: {
    gradient:
      'linear-gradient(to right, var(--colors-campaign-yellow-1), white)',
    topGradient: `linear-gradient(to right, var(--colors-campaign-yellow-4), var(--colors-campaign-yellow-2))`,
    cardText: 'text-campaign/yellow-4',
    button: {
      border: 'border-colors/campaign-yellow-4',
      text: 'text-colors/campaign-yellow-4',
    },
  },
  orange: {
    gradient:
      'linear-gradient(to right, var(--colors-campaign-orange-1), white)',
    topGradient: `linear-gradient(to right, var(--colors-campaign-orange-4), var(--colors-campaign-orange-2))`,
    cardText: 'text-campaign/orange-4',
    button: {
      border: 'border-colors/campaign-orange-4',
      text: 'text-colors/campaign-orange-4',
    },
  },
};
export const getColorSchema = (color: string) => {
  if (!Object.keys(colorSchema).includes(color?.toLowerCase())) {
    return colorSchema.green;
  }
  return colorSchema[color.toLowerCase() as ColorType];
};
